export default {
	savingMessage: 'Sauvegarde en cours',
	saveMessage: 'Données non sauvegardées',
	savedMessage: 'Données sauvegardées',
	saveBtn: 'J\'ai terminé',
	errorMessage: 'Sauvegarde impossible',
	projectClosed: 'L\'expérimentation EDS étant terminée, il n\'est plus possible de modifier ces questionnaires patients'
};
